import React, { Component } from 'react'

export default class PaymentFailse extends Component {



    render() {
        return (
            <section className='pricing-area padding-top-100px padding-bottom-80px'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12 mt-3'>
                            <div className='success-payment'>
                                <div className='success-img'>
                                    <img src={'./assets/images/failed-img.jpg'} />
                                </div>
                                <div className='success-head'>
                                    Your payment failed
                                </div>
                                <div className='success-text'>
                                    Please try again!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        )
    }
}
